import React from "react";
import Reviews from "../../componets/Reviews";
import shopifyPlusReviewsJson from "../../data/shopifyPlusReviews.json";
import { NavLink } from "react-router-dom";

export default function Section6() {
  const reviewData = shopifyPlusReviewsJson;

  return (
    <div className="w-full Section5 mt-[0px] md:mt-0 p-[2%] text-center mb-[40px] md:mb-[3%] bg-cover">
      <div className="w-full section4-container">
        <Reviews testimonials={reviewData} plus />

        <div className="w-full mt-6">
          <NavLink
            to="/testimonial"
            className="inline-block py-[10px] px-[30px] bg-[#DA2128] rounded-[3px] font-bold text-white border-none leading-[1.15]"
          >
            View Our Client
          </NavLink>
        </div>
      </div>
    </div>
  );
}
